import { Link, useRouter } from 'found';
import find from 'lodash/find';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LegalIcon from '@mui/icons-material/AccountBalance';
import HelpIcon from '@mui/icons-material/HelpOutline';
import List from '@mui/material/List';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import RSLogoLight from 'assets/RS_logo-white.png';
import RSLogo from 'assets/RS_logo.png';
import { useTheme } from '@mui/material';
import styles from './index.scss';
import { renderListItems } from './RenderList';

export const muiStyles = {
  badge: { top: 16 },
  drawer: {
    overflow: 'hidden',
  },
  header: {
    iconClose: { top: '10px' },
    innerDiv: {
      height: 70,
      display: 'flex',
      alignItems: 'center',
    },
  },
  listItem: {
    paddingTop: 0,
    paddingBottom: 0,
    rightAvatar: { margin: '5px 0' },
    root: {},
  },
  selectableList: {
    selectedItem: {
      fontWeight: '600',
    },
    root: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
};

const AppDrawer = ({ items, onClick, onRequestChange, open, width = 300 }) => {
  const theme = useTheme();
  const {
    match: {
      location: { pathname },
    },
    router,
  } = useRouter();
  const [expandedItem, setExpandedItem] = useState(null);
  const locationPath = pathname.split('/')[1];
  const listItems = items.concat([
    '-',
    {
      key: 'help',
      icon: <HelpIcon />,
      label: 'Help',
      handler: useCallback(() => {
        if (window) {
          window.open('http://help.ripplestreet.com', '_blank');
        }
      }, []),
    },
    {
      key: 'legal',
      icon: <LegalIcon />,
      label: 'Legal',
      children: [
        {
          key: 'terms-of-service',
          label: 'Terms of Service',
          path: '/terms-of-service',
        },
        // {
        //   key: 'code-of-conduct',
        //   label: 'Code of Conduct',
        //   path: '/code-of-conduct',
        // },
        {
          key: 'privacy-policy',
          label: 'Privacy Policy',
          path: '/privacy-policy',
        },
      ],
    },
  ]);
  const childPathMatch = useCallback(
    child => child.path.split('/')[1] === locationPath,
    [locationPath],
  );
  const active = find(listItems, item => {
    if (item.children) {
      return item.children.some(childPathMatch);
    }
    if (item.path) {
      return item.path.split('/')[1] === locationPath;
    }
    return false;
  });

  const onChange = useCallback(
    (e, item) => {
      if (item) {
        if (item.handler) {
          item.handler();
        }
        if (item.path) {
          router.push(item.path);
        }
        if (!item.children) {
          onClick();
        }
        if (item?.children) {
          setExpandedItem(item);
        } else {
          setExpandedItem(null);
        }
      } else {
        onClick();
      }
    },
    [onClick, router],
  );

  return (
    <Drawer
      docked={false}
      onRequestChange={onRequestChange}
      open={open}
      style={muiStyles.drawer}
      width={width}
    >
      <div style={{ width }} className={styles.container}>
        <div className={styles.header}>
          <Link to='/'>
            <img
              alt='logo'
              className={styles.logo}
              src={theme.palette.mode === 'dark' ? RSLogoLight : RSLogo}
            />
          </Link>
          <IconButton onClick={onClick} size='large'>
            <CloseIcon color='#FFF' />
          </IconButton>
        </div>
        <List
          className={styles.list}
          selectedItemStyle={muiStyles.selectableList.selectedItem}
          style={muiStyles.selectableList.root}
          value={active}
        >
          {renderListItems(listItems, active, onChange, expandedItem)}
        </List>
      </div>
    </Drawer>
  );
};

AppDrawer.propTypes = {
  items: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onRequestChange: PropTypes.func,
  open: PropTypes.bool,
  selected: PropTypes.object,
  width: PropTypes.number,
};

export default AppDrawer;
